import { onMounted, onUnmounted, ref } from 'vue';
/* eslint-disable */
export default function useScroll(el, fn) {
  const windowHeight = ref(null);
  const documentRectBottom = ref(null);
  const isHittingBottom = ref(false);

  const scrollHandler = () => {
    const _windowHeight = window.innerHeight;
    const _documentRectBottom = el.getBoundingClientRect().bottom
    windowHeight.value = _windowHeight;
    documentRectBottom.value = _documentRectBottom;

    if (_windowHeight >= _documentRectBottom) {
      fn()
    }
  };

  onMounted(() => {
    window.addEventListener('scroll', scrollHandler);
  });
  onUnmounted(() => {
    window.removeEventListener('scroll', scrollHandler);
  });

  return {
    windowHeight,
    documentRectBottom,
    isHittingBottom,
  }
}
